(function () {
  function getSectionId() {
    const el = document.querySelector('[data-uniform-upsell-wrapper]');
    return el ? el.dataset.sectionId : null;
  }

  function stripAnimations(root) {
    root.querySelectorAll('[data-animation]').forEach((el) => {
      el.removeAttribute('data-animation');
      el.removeAttribute('data-animation-duration');
      el.removeAttribute('data-animation-delay');
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
    return root;
  }

  let refreshing = false;

  async function refreshCart(sectionsHtml) {
    if (refreshing) return;
    refreshing = true;
    try {
      let html = null;

      if (sectionsHtml) {
        const keys = Object.keys(sectionsHtml);
        if (keys.length) html = sectionsHtml[keys[0]];
      }

      if (!html) {
        const sid = getSectionId();
        if (sid) {
          const res = await window.__origFetch(`${window.location.pathname}?section_id=${sid}`);
          html = await res.text();
        }
      }

      if (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const freshItems = doc.querySelector('[data-items-holder]');
        const currentItems = document.querySelector('[data-items-holder]');
        if (freshItems && currentItems) {
          stripAnimations(freshItems);
          currentItems.innerHTML = freshItems.innerHTML;
        }

        const freshPrice = doc.querySelector('[data-cart-price-holder]');
        const currentPrice = document.querySelector('[data-cart-price-holder]');
        if (freshPrice && currentPrice) {
          stripAnimations(freshPrice);
          currentPrice.innerHTML = freshPrice.innerHTML;
        }

        const freshUpsell = doc.querySelector('[data-uniform-upsell-wrapper]');
        const currentUpsell = document.querySelector('[data-uniform-upsell-wrapper]');
        if (freshUpsell && currentUpsell) {
          stripAnimations(freshUpsell);
          currentUpsell.innerHTML = freshUpsell.innerHTML;
        }
      }

      const cart = await window.__origFetch('/cart.js').then((r) => r.json());
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.dataset.cartCount = cart.item_count;
      });

      const drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.classList.toggle('is-empty', cart.item_count === 0);
    } catch (err) {
      console.error('[uniform-upsell] refresh failed', err);
    } finally {
      refreshing = false;
    }
  }

  document.addEventListener('change', (e) => {
    const select = e.target.closest('[data-uniform-size]');
    if (!select) return;
    const btn = select.closest('.uniform-card__info').querySelector('[data-uniform-add]');
    if (btn) {
      btn.dataset.variantId = select.value;
      btn.disabled = !select.value;
    }
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-uniform-add]');
    if (!btn) return;

    const variantId = Number(btn.dataset.variantId);
    if (!variantId) {
      console.error('[uniform-upsell] Invalid variant ID:', btn.dataset.variantId);
      return;
    }

    btn.disabled = true;
    const sectionId = getSectionId();

    try {
      const res = await window.__origFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: sectionId ? [sectionId] : []
        })
      });

      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(`Add failed: ${res.status} — ${body.description || ''}`);
      }

      const data = await res.json();
      await refreshCart(data.sections);
    } catch (err) {
      console.error('[uniform-upsell]', err);
      btn.disabled = false;
    }
  });

  window.__origFetch = window.fetch.bind(window);
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    const promise = window.__origFetch(...args);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      promise.then(() => setTimeout(() => refreshCart(null), 250)).catch(() => {});
    }
    return promise;
  };
})();